(function() { window.GUID_2f06fa9f_2db0_4158_b8fb_e7edf36456c0 = { getGuid: function() { return "2f06fa9f-2db0-4158-b8fb-e7edf36456c0"; } }; })();
var ChartAutoRefresh;
(function (ChartAutoRefresh) {
    var refresh = parseInt($('#OneItemRefreshTime').val(), 10);
    if (refresh && refresh > 100) {
        setInterval(function () {
            var canvas = $('#Canvas');
            CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/ChartFullScreenForAutoRefresh/" + CSParameters.SportEventId + window.location.search, null, function (queryResult) {
                canvas[0].innerHTML = queryResult;
            });
        }, refresh);
    }
})(ChartAutoRefresh || (ChartAutoRefresh = {}));

//# sourceMappingURL=ChartAutoRefresh.js.map
